import React from "react";
import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
import Breadcrumb from "../../components/breadcrumb/Breadcrumb.component";
import ProfileContainer from "../../containers/profile/Profile.container";
import MetaComp from "../../components/meta-comp/MetaComp.component";
import BreadcrumbContextApi from "../../context/BreadcrumbContextApi.context";
import "./Profile.styles.css";

const ProfilePage = () => {
  const { t } = useTranslation();
  const [modalIsOpen, setModalIsOpen] = React.useState(false);

  const breadcrumbData = [
    {
      iconClass: regular("house"),
      link: "/",
    },
    {
      label: t("profile"),
    },
  ];
  const modalIsOpenHander = () => {
    setModalIsOpen(!modalIsOpen);
  };

  return (
    <BreadcrumbContextApi.Provider value={{ modalIsOpen, modalIsOpenHander }}>
      <div className="cm-profile-container cm-cand-page-container bg-white position-relative">
        <MetaComp title={t("profile_page_title")} />
        <Breadcrumb data={breadcrumbData} />
        <ProfileContainer t={t} />
        <Outlet />
      </div>
    </BreadcrumbContextApi.Provider>
  );
};

export default ProfilePage;
